import axiosInstance from '../axiosConfigCMS';

export default {
  async getBanners() {
    const response = await axiosInstance.get('/home-banners');
    return response.data;
  },
  async getSlider() {
    const response = await axiosInstance.get('/home-sliders');
    const data = response.data.filter((slide) => slide.SEO !== 'SEO_FBO_SITE');
    return data;
  },
};
